/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.GET_DEPRECIATION_LIST,
    'api/v1/rpt/administrator/buildings/settings/building_depreciation_rates',
    payload,
    callback
  );

export const showData = (id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_depreciation_rates/${id}`,
    payload,
    callback
  );

export const createData = (payload, callback) =>
  req.create(
    c.CREATE_DATA,
    'api/v1/rpt/administrator/buildings/settings/building_depreciation_rates',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (id, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_depreciation_rates/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeData = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DATA,
    `api/v1/rpt/administrator/buildings/settings/building_depreciation_rates/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getOrdinanceRevisionList = (payload, callback) =>
    req.list(
      c.GET_ORDINANCE_REVISION_LIST,
      `api/v1/rpt/administrator/settings/ordinance_revisions`,
      payload,
      callback
    );

    export const clearItem = (constant, value) => req.setItem(constant, value);